<template>
  <VcProductCard view-mode="list">
    <template #media>
      <router-link :to="link" class="contents" @click="$emit('linkClick', $event)">
        <VcProductImage :img-src="product.imgSrc" :alt="product.name" size-suffix="sm" lazy />
      </router-link>
    </template>

    <VcProductTitle
      :lines-number="2"
      fix-height
      :to="link"
      :title="product.name"
      @click="$emit('linkClick', $event)"
      @keyup.enter="$emit('linkClick', $event)"
      @keydown.arrow-up.arrow-left="$emit('changeFocus', { direction: 'UP', event: $event })"
      @keydown.arrow-down.arrow-right="$emit('changeFocus', { direction: 'DOWN', event: $event })"
    >
      {{ product.name }}
    </VcProductTitle>

    <!-- Innovadis custom if statement and prices added-->
    <VcProductPrice
      v-if="showAnonymousCustomerPrices || isAuthenticated"
      :actual-price="product.price.actual"
      :list-price="product.price.list"
      :with-from-label="product.hasVariations"
    />
  </VcProductCard>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getProductRoute } from "@/core/utilities";
import type { Product } from "@/core/api/graphql/types";
import type { RouteLocationRaw } from "vue-router";
import { useModuleSettings } from "@/core/composables/useModuleSettings";
import { useUser } from "@/shared/account";
import { API_MANAGEMENT_MODULE, ENABLE_SHOW_ANONYMOUS_PRICES } from "@/core/constants";

// Innovadis custom check
const { getSettingValue } = useModuleSettings(API_MANAGEMENT_MODULE);
const showAnonymousCustomerPrices = getSettingValue(ENABLE_SHOW_ANONYMOUS_PRICES);
const { isAuthenticated } = useUser();

interface IEmits {
  (eventName: "linkClick", globalEvent: PointerEvent): void;
  (eventName: "changeFocus", value: { direction: "UP" | "DOWN"; event: KeyboardEvent }): void;
}

interface IProps {
  product: Product;
}

defineEmits<IEmits>();
const props = defineProps<IProps>();

const link = computed<RouteLocationRaw>(() => getProductRoute(props.product.id, props.product.slug));
</script>
